import PropTypes from 'prop-types'
import { Component } from 'react'

import StickyHeader from 'components/sticky-header'
import PostLink from '../post-link'

export default class PostNavBar extends Component {
  static propTypes = {
    hideTitle: PropTypes.bool,
    nextPost: PropTypes.object,
    previousPost: PropTypes.object,
    shareProps: PropTypes.object,
    title: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
      .isRequired,
  }

  static contextTypes = {
    minimalView: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.state = { microUtilityEnabled: false }
  }

  componentDidMount() {
    this.setState({
      microUtilityEnabled:
        window &&
        !window.currentUser &&
        !window.location.href.includes('embedded'), // Never show micro utility bar in in-app views
    })
  }

  previousPostButton = () =>
    this.props.previousPost ? (
      <PostLink
        className="hidden-xs"
        direction="left"
        post={this.props.previousPost}
      />
    ) : null

  nextPostButton = () =>
    this.props.nextPost ? (
      <div className="hidden-xs full-width text-right">
        <PostLink direction="right" post={this.props.nextPost} />
      </div>
    ) : null

  render() {
    const { children, title, hideTitle } = this.props
    return (
      <StickyHeader
        hideTitle={this.context.minimalView}
        leftActionComponent={<>{this.previousPostButton()}</>}
        rightActionComponent={this.nextPostButton()}
        title={title}
        utilityBarEnabled={this.state.microUtilityEnabled}
      >
        {children}
      </StickyHeader>
    )
  }
}
